/* eslint-disable arrow-body-style,import/no-cycle */
import {
    IAccreditationCenterDetails,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';


const initialState: State = {
    accreditationCenterDetails: null,
};

export default createModel({
    state: initialState,
    reducers: {
        clearAccreditationCenterDetails(state: State): State {
            return {
                ...state,
                accreditationCenterDetails: null,
            };
        },

        setAccreditationCenterDetails(state: State, accreditationCenterDetails: IAccreditationCenterDetails): State {
            return {
                ...state,
                accreditationCenterDetails,
            };
        },
    },
    effects: (dispatch: any) => ({
        async fetchAccreditationCenterDetails(centerId: string) {
            const accreditationCenterDetails = await apiConnector.execApi(dispatch, apiClient => apiClient.getAttestationSubCommission(centerId));
            this.setAccreditationCenterDetails(accreditationCenterDetails);
        },
    }),
});

interface State {
    accreditationCenterDetails: IAccreditationCenterDetails | null;
}
